//React component
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { Modal, Col, ListGroup, Badge, Row, Button, Alert, Container } from 'react-bootstrap';
//Img
import { RenderIf } from '../utils/RenderIf';
import Modalclient from './ModalClients';

//Api 
import { ClientsFetchAPI } from '../../api/Clients';
import ModalCreateNewClient from './ModalCreateNewClient';
import ModalAddressClient from "./Maps/ModalAddressClient";

//Alerts
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';

import SuccessAlert from '../Alerts/SuccessAlert';


const ModalClientProfile = ({ dataClientSelected, setdataClientSelected, addressNowLocation, setAddressNowLocation, parthner_order }) => {
    let business = 0

    //We validate if the machine is logged in
    if (business !== null && business !== undefined && business !== '') {
        business = JSON.parse(localStorage.getItem('business'))
    }
    let token = localStorage.getItem('x-access-machine-token');
    const [showModalSetting, setshowModalSetting] = useState(false)
    //const [dataClientSelected, setdataClientSelected] = useState(null)
    const [edit, setedit] = useState(false)

    const [Name, setName] = useState(dataClientSelected !== null && dataClientSelected.name !== undefined ? dataClientSelected.name : '');
    const [Phone, setPhone] = useState(dataClientSelected !== null && dataClientSelected.phone !== undefined ? dataClientSelected.phone : '');
    const [nickname, setNickname] = useState(dataClientSelected !== null && dataClientSelected.nickname !== undefined ? dataClientSelected.nickname : '');
    const [Email, setEmail] = useState(dataClientSelected !== null && dataClientSelected.email !== undefined ? dataClientSelected.email : '');
    const [Ruc, setRuc] = useState(dataClientSelected !== null && dataClientSelected.ruc !== undefined ? dataClientSelected.ruc : '');
    const [Dv, setDv] = useState(dataClientSelected !== null && dataClientSelected.dv !== undefined ? dataClientSelected.dv : '');


    const [addressClient, setAddressClient] = useState([])
    //const [addressNowLocation, setAddressNowLocation] = useState(null);
    const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });

    //get client by business 
    const getClientsByBusiness = async () => {

        return new Promise(async (resolve, reject) => {
            try {

                let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
                let business_id = business.id
                if (parthner_order == true) {
                    business_id = branchoffice.parthner_business
                }
                const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
                resolve(response.data.data);
            } catch (err) {
                console.log(err);
                reject(err);
            }
        });
    }

    const editUser = async () => {
        LoadingAlert('Editando usuario')
        let token = localStorage.getItem('x-access-machine-token')
        let business = JSON.parse(localStorage.getItem('business'))


        let data = {};

        if (Name !== dataClientSelected.name) data.name = Name;
        if (Phone !== dataClientSelected.phone) data.phone = Phone;
        if (Email !== dataClientSelected.email) data.email = Email;
        if (nickname !== dataClientSelected.nickname) data.nickname = nickname;
        if (Ruc !== dataClientSelected.ruc) data.ruc = Ruc;
        if (Dv !== dataClientSelected.dv) data.dv = Dv;

        // Estos campos siempre se envían
        data.business_code = business.code;
        data.client_type_id = 2;


        try {
            const response = await ClientsFetchAPI.updateClient(data, dataClientSelected.id, token)
            ErrorAlert('', 'Usuario actualizado con exito', 'success')
            const responseClients = await getClientsByBusiness()
            let clientUpdated = responseClients.find(client => client.id === dataClientSelected.id);
            setdataClientSelected(clientUpdated);
            setedit(false)
        } catch (err) {
            console.log(err)
            ErrorAlert('', err.response.data.error ? err.response.data.error : "Error al crear usuario", 'error')

        }

    }




    //get address by client
    const getAddressClientNow = async () => {
        try {
            const response = await ClientsFetchAPI.getAddressClient(dataClientSelected.id, token);

            setAddressClient(response.data.data)

            console.log(coordinates);

        } catch (err) {
            setAddressClient([])
            console.log("Error al obtener las direcciones del cliente: ", err);
        }
    }

    useEffect(() => {
        // We get the client data if it exists
        if (dataClientSelected && dataClientSelected !== null) {
            getAddressClientNow();
            setAddressNowLocation(null)
        }

        if (dataClientSelected) {
            setName(dataClientSelected.name || '');
            setPhone(dataClientSelected.phone || '');
            setNickname(dataClientSelected.nickname || '');
            setEmail(dataClientSelected.email || '');
            setRuc(dataClientSelected.ruc || '');
            setDv(dataClientSelected.dv || '');
        } else {
            setName('');
            setPhone('');
            setNickname('');
            setEmail('');
            setRuc('');
            setDv('');
        }
    }, [dataClientSelected]);

    useEffect(() => {

    }, [addressNowLocation]);



    return (
        <>



            <div class="p-2">{dataClientSelected !== null ? <>
                <div className='col-12 col-md-12 d-flex justify-content-center bg-white p-2 m-1  rounded-3  shadow-sm' >
                    {/* Card */}
                    <label className="card-restaurant">


                        <span className="plan-details">

                            <div className="d-flex justify-content-start">


                                <div className='m-2'>

                                    <span className="plan-type" translate='no'><i class="uil uil-user-location"></i> Cliente: {dataClientSelected.name}  <br></br>
                                        <i class="uil uil-phone-volume"></i> Telefono: {dataClientSelected.phone} <br></br><i class="uil uil-fast-mail"></i> Email: {dataClientSelected.email}</span>
                                    <p className="plan-description" translate='no'><i class="uil uil-estate"></i> Direccion:{addressNowLocation !== null ? addressNowLocation.name : "No hay direccion seleccionada"}</p>

                                    <div className='d-flex justify-content-between align-items-center'>

                                        <Badge className='p-2' bg="warning" text="dark" onClick={() => setshowModalSetting(true)}>
                                            <i class="uil uil-user-exclamation">Ver detalle</i>
                                        </Badge>
                                    </div>


                                </div>
                            </div>
                        </span>
                    </label>

                </div ></> : <>  <div className='col-12 col-md-12 d-flex justify-content-center bg-white p-2 m-1  rounded-3  shadow-sm' onClick={() => setshowModalSetting(true)}  >
                    {/* Card */}
                    <label className="card-restaurant">
                        <span className="plan-details">

                            <div className="">
                                <div className='m-2'>
                                    <div className="d-flex justify-content-center align-items-center"><i class="uil uil-user-exclamation" style={{ fontSize: "2.5rem" }}></i> </div>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <h1 class="badge bg-light text-secondary text-center">No hay un cliente seleccionado <br></br> Selecciona uno aqui</h1>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </label>

                </div ></>}</div>


            <Modal
                className='bg-blur-sp'
                show={showModalSetting}
                size='xl'
                onHide={() => setshowModalSetting(false)}
                aria-labelledby="example-custom-modal-styling-title"
                centered>
                <Modal.Body>

                    <div className="" >
                        <div className="d-flex justify-content-center border-bottom-0">
                            <h2 className="modal-title fw-bold fs-5">
                                <i class="uil uil-users-alt"></i> Detalle del Cliente
                            </h2>
                        </div>
                        <div className=" fade show active p-5 " id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                            <div className='container'>
                                <div className='row d-flex justify-content-center alight-item-center'>


                                    {dataClientSelected && dataClientSelected !== null ? <>
                                        <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='d-flex  justify-content-between position-relative'>
                                                <div className='m-1'><Modalclient getClientsByBusiness={getClientsByBusiness} callCenter={true} setdataClientSelected={setdataClientSelected} dataClientSelected={dataClientSelected} ></Modalclient></div>

                                                <div className=' border m-1 p-2 rounded-3  shadow-sm w-100'>
                                                    <div className="d-flex justify-content-center border-bottom-0">
                                                        <h2 className="modal-title fw-bold fs-5">
                                                            <i class="uil uil-user-circle"> {dataClientSelected.name}</i>
                                                        </h2>
                                                    </div>
                                                    <div className='d-flex justify-content-center align-items-center'>

                                                        <Badge className='p-2' bg="dark" text="white" onClick={() => (setdataClientSelected(null), setAddressNowLocation(null), setshowModalSetting(true))}>
                                                            <i class="uil uil-minus-circle"> Remover  cliente</i>
                                                        </Badge>
                                                    </div>

                                                </div>


                                            </div>

                                            {/*Form */}
                                            <Container>
                                                <Row>
                                                    <Col>
                                                        <div className='mt-3'>
                                                            <ListGroup as="ol" >
                                                                <Form
                                                                    className="needs-validation"

                                                                >

                                                                    <Form.Group className="mb-3" controlId="name"></Form.Group>
                                                                    <ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-center align-items-start"
                                                                    ><button type="button" className='btn btn-outline-primary pulse rounded-3 p-2 lh-1 border'
                                                                        onClick={() => (edit == false ? setedit(true) : setedit(false))}
                                                                    ><i class="uil uil-edit"> Editar Cliente</i>
                                                                        </button></ListGroup.Item>

                                                                    <ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-between align-items-start"
                                                                    >
                                                                        {edit == false ? <><div className="ms-2 me-auto">
                                                                            <div className="fw-bold">Nombre</div>
                                                                            {dataClientSelected.name}
                                                                        </div></> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="name">
                                                                            <Form.Label>Nombre</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={Name}
                                                                                onChange={e => setName(e.target.value)}
                                                                                placeholder={dataClientSelected.name}
                                                                                name="name"
                                                                            />
                                                                        </Form.Group></div>}
                                                                    </ListGroup.Item>

                                                                    {/*<ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-between align-items-start"
                                                                    >
                                                                        {edit == false ? <><div className="ms-2 me-auto">
                                                                            <div className="fw-bold">Nombre de usuario</div>
                                                                            {dataClientSelected.nickname}
                                                                        </div></> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="nickname">
                                                                            <Form.Label>Nombre de usuario</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={nickname}
                                                                                onChange={e => setNickname(e.target.value)}
                                                                                placeholder={dataClientSelected.nickname}
                                                                                name="nickname"
                                                                            />
                                                                        </Form.Group></div>}
                                                                    </ListGroup.Item>*/}
                                                                    <ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-between align-items-start"
                                                                    >
                                                                        {edit == false ? <><div className="ms-2 me-auto">
                                                                            <div className="fw-bold">Email</div>
                                                                            {dataClientSelected.email}
                                                                        </div></> : <> <Form.Group className="mb-3 w-100" controlId="email">
                                                                            <Form.Label>Email</Form.Label>
                                                                            <Form.Control
                                                                                type="text" rows={3}
                                                                                value={Email}
                                                                                onChange={e => setEmail(e.target.value)}
                                                                                placeholder={dataClientSelected.email}
                                                                                name="email"
                                                                            />
                                                                        </Form.Group></>}
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-between align-items-start"
                                                                    >
                                                                        {edit == false ? <><div className="ms-2 me-auto">
                                                                            <div className="fw-bold">Ruc</div>
                                                                            {dataClientSelected.ruc}
                                                                        </div></> : <> <Form.Group className="mb-3 w-100" controlId="ruc">
                                                                            <Form.Label>Ruc</Form.Label>
                                                                            <Form.Control
                                                                                type="text" rows={3}
                                                                                value={Ruc}
                                                                                onChange={e => setRuc(e.target.value)}
                                                                                placeholder={dataClientSelected.ruc}
                                                                                name="txt"
                                                                            />
                                                                        </Form.Group></>}
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-between align-items-start"
                                                                    >
                                                                        {edit == false ? <><div className="ms-2 me-auto">
                                                                            <div className="fw-bold">Dv</div>
                                                                            {dataClientSelected.dv}
                                                                        </div></> : <> <Form.Group className="mb-3 w-100" controlId="dv">
                                                                            <Form.Label>Dv</Form.Label>
                                                                            <Form.Control
                                                                                type="text" rows={3}
                                                                                value={Dv}
                                                                                onChange={e => setDv(e.target.value)}
                                                                                placeholder={dataClientSelected.dv}
                                                                                name="txt"
                                                                            />
                                                                        </Form.Group></>}
                                                                    </ListGroup.Item>
                                                                    <ListGroup.Item
                                                                        as="li"
                                                                        className="d-flex justify-content-between align-items-start"
                                                                    >

                                                                        {edit == false ? <><div className="ms-2 me-auto">
                                                                            <div className="fw-bold">Telefono</div>
                                                                            {dataClientSelected.phone}
                                                                        </div></> : <>
                                                                            <Form.Group className="mb-3 w-100" controlId="phone">
                                                                                <Form.Label>Teléfono</Form.Label>
                                                                                <PhoneInput
                                                                                    country={'pa'} // País inicial, puedes cambiarlo
                                                                                    value={Phone}
                                                                                    onChange={phone => (setPhone(phone))}
                                                                                    inputProps={{
                                                                                        name: 'phone',
                                                                                        required: true,
                                                                                        autoFocus: true
                                                                                    }}
                                                                                    countryCodeEditable={false}
                                                                                    enableSearch
                                                                                />
                                                                            </Form.Group>
                                                                        </>}
                                                                    </ListGroup.Item>

                                                                    <RenderIf isTrue={edit == false}>
                                                                        <ListGroup.Item
                                                                            as="li"
                                                                            className="d-flex justify-content-between align-items-start"
                                                                        ><div className="ms-2 me-auto">
                                                                                <div className="fw-bold">Puntos:</div>
                                                                                {dataClientSelected.points}
                                                                            </div>
                                                                        </ListGroup.Item>
                                                                    </RenderIf>



                                                                    <RenderIf isTrue={edit == true}>
                                                                        <ListGroup.Item
                                                                            as="li"
                                                                            className="d-flex justify-content-between align-items-start"
                                                                        >
                                                                            <div className="mt-3 d-flex justify-content-end">

                                                                                <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                                                                    onClick={() => setedit(false)} >
                                                                                    <i class="uil uil-times-circle"></i>  Cancelar
                                                                                </button>
                                                                            </div>
                                                                            <div className="mt-3 d-flex justify-content-end">

                                                                                <button type="button" className='btn bg-success-subtle text-success  border-0 fw-bold '
                                                                                    onClick={() => editUser()} >
                                                                                    <i class="uil uil-save"></i> Guardar
                                                                                </button>
                                                                            </div>
                                                                        </ListGroup.Item>
                                                                    </RenderIf>
                                                                </Form>

                                                            </ListGroup>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className='mt-3'>
                                                            <ListGroup as="ol" >
                                                                <ListGroup.Item as="li" className="d-flex justify-content-center align-items-start">
                                                                    <ModalAddressClient client_id={dataClientSelected.id} addressClient={addressClient} getAddressClientNow={getAddressClientNow} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} coordinates={coordinates} ></ModalAddressClient>
                                                                </ListGroup.Item>
                                                            </ListGroup>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div></> : <>
                                        <div className='d-flex  justify-content-between position-relative'>
                                            <div className='m-1'><Modalclient getClientsByBusiness={getClientsByBusiness} callCenter={true} setdataClientSelected={setdataClientSelected} dataClientSelected={dataClientSelected} ></Modalclient>
                                            </div>
                                        </div>

                                        <small className='text-body-tertiary text-center'>
                                            <i className="uil uil-info-circle me-1"></i>
                                            Por favor, seleccione un cliente o cree uno nuevo.
                                        </small></>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='d-block mt-lg-1 mt-0'>
                        <div className='d-flex justify-content-end mt-2'>
                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                onClick={() => (setshowModalSetting(false))}
                            >
                                <i class="uil uil-times-circle"></i>  Cerrar
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal >










        </>
    )
}

export default ModalClientProfile;